import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { apiUrl } from "../../config";

const initialState = {
  id: 0,
  name: "",
  imageUrl: "",
};

const CategoryForm = ({ onSave, initialData, readOnly }) => {
  const [category, setCategory] = useState(initialState);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    return () => {
      if (previewImage && previewImage.startsWith("blob")) {
        URL.revokeObjectURL(previewImage);
      }
    };
  }, [previewImage]);

  useEffect(() => {
    if (initialData) {
      setCategory(initialData);
      if (initialData.imageUrl) {
        if (typeof initialData.imageUrl === "string") {
          // Existing image URL
          setPreviewImage(apiUrl + "/" + initialData.imageUrl);
        } else if (initialData.imageUrl instanceof File) {
          // New file selected
          const url = URL.createObjectURL(initialData.imageUrl);
          setPreviewImage(url);
        }
      } else {
        setPreviewImage(null);
      }
    } else {
      setCategory(initialState);
      setPreviewImage(null);
    }
  }, [initialData]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCategory((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCategory((prev) => ({ ...prev, imageUrl: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(category);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={4}>
          <Form.Group controlId="name">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={category.name}
              onChange={handleChange}
              disabled={readOnly}
              required
            />
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group controlId="image">
            <Form.Label>Image</Form.Label>
            <Form.Control
              type="file"
              onChange={handleFileChange}
              disabled={readOnly}
            />
            {previewImage && (
              <div className="mt-2">
                <img
                  src={previewImage}
                  alt="Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    marginTop: "10px",
                  }}
                />
              </div>
            )}
          </Form.Group>
        </Col>
      </Row>
      {!readOnly && (
        <Row>
          <Col>
            <div className="form-buttons">
              <Button type="submit" className="me-2">
                Save
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setCategory(initialState);
                  setPreviewImage(null);
                }}
              >
                Clear
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </Form>
  );
};

export default CategoryForm;
